import React, { ReactElement } from 'react';
import { Modal, MODAL_ANIMATION_TYPE, MODAL_CLOSE_BUTTON, MODAL_TYPE } from 'b2b-components/theme/components/Modal';
import { ModalContent } from './ModalContent';
import { ComponentType, Props } from './';

export const FeatureOnboarding: ComponentType = ({
  entry,
  isOpen,
  onDismiss,
  modalButtonLabel,
}: Props): ReactElement | null => {
  if (!entry) {
    return null;
  }

  const { data } = entry;

  return (
    <Modal
      animationType={MODAL_ANIMATION_TYPE.fade}
      closeButton={MODAL_CLOSE_BUTTON.right}
      content={() => (
        <ModalContent
          data={data}
          onDismiss={onDismiss}
          buttonLabel={modalButtonLabel}
        />
      )}
      isOpen={isOpen}
      onCloseModal={onDismiss}
      type={MODAL_TYPE.onBoarding}
      text={{
        ariaCloseModal: data.button_label,
        ariaLabel: data.title,
      }}
      dataAttributes={{
        'data-test': 'featureOnboardingModal',
      }}
    />
  );
};
